export const SEARCH_ACTION = 'SEARCH_ACTION';
export const SEARCH_SUCCESS_ACTION = 'SEARCH_SUCCESS_ACTION';
export const SEARCH_FAILURE_ACTION = 'SEARCH_FAILURE_ACTION';
